import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import CopyWrapper from 'components/Common/CopyWrapper';
import DatePickerCustom from 'components/Common/DatePickerCustom';
import DropdownStatus from 'components/Common/DropdownStatus';
import LabelWrapper from 'components/Common/LabelWrapper';
import ModalConfirm from 'components/Common/ModalConfirm';
import TooltipCustom from 'components/Common/TooltipCustom';
import { useRole } from 'components/Hooks/UserHooks';
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';
import { AI_MODEL_NEWS_STOCK_OPTIONS, EXCEL_UPLOAD_STATUS_OPTIONS, EXCEL_UPLOAD_TYPE } from 'helpers/constans';
import { formatNumberWithCommas } from 'helpers/format';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CountUp from 'react-countup';
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CardBody, CardHeader, Col, Row, Spinner } from "reactstrap";
import { createSelector } from "reselect";
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import TableContainer from "../../../components/Common/TableContainer";
import { cancelNewsStockSchedule, getNewsStockSchedules as onGetNewsStockSchedules } from "../../../store/thunks";


export interface Tag {
    id: string;
    text: string;
}

const TYPE_SELECT_DEFAULT: string = 'schedule_upload_date';

registerLocale('en', en);
registerLocale('ko', ko);

const ScheduleList = (activeTab?: any) => {
    const { t, i18n } = useTranslation();
    const { userPermissions } = useRole();

    const EXCEL_UPLOAD_STATUS_OPTIONS_COLOR = {
        '1': 'primary',
        '2': 'success',
        '3': 'danger',
        '4': 'warning',
    };

    const EXCEL_UPLOAD_STATUS_OPTIONS_LANG = EXCEL_UPLOAD_STATUS_OPTIONS?.map((item: any) => ({
        value: item?.value,
        label: t(item?.label),
    }));

    const AI_MODEL_NEWS_STOCK_OPTIONS_LANG: any = AI_MODEL_NEWS_STOCK_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));


    const [query, setQuery]: any = useQueryParams({
        time_request: withDefault(NumberParam, 0),
        page: withDefault(NumberParam, 1),
        limit: withDefault(NumberParam, 30),
        sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
        order_by: withDefault(StringParam, 'ASC'),
        type: withDefault(StringParam, String(EXCEL_UPLOAD_TYPE.STOCK_NEWS)),
        status: withDefault(StringParam, String(EXCEL_UPLOAD_STATUS_OPTIONS[0]?.value)),
        start_schedule_upload_date: withDefault(StringParam, ''),
        end_schedule_upload_date: withDefault(StringParam, ''),
        start_created_at: withDefault(StringParam, moment().format('Y-MM-DD')),
        end_created_at: withDefault(StringParam, moment().format('Y-MM-DD')),
    });

    const [statusSearch, setStatusSearch] = useState<typeof EXCEL_UPLOAD_STATUS_OPTIONS_LANG[0] | null>(EXCEL_UPLOAD_STATUS_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.status)) || null);

    const [dateCreatedSearch, setDateCreatedSearch] = useState<any[]>([query?.start_created_at ? moment(query?.start_created_at, 'Y-MM-DD').toDate() : null, query?.end_created_at ? moment(query?.end_created_at || '', 'Y-MM-DD').toDate() : null]);
    const [startDateCreated, endDateCreated] = dateCreatedSearch;

    const [dateScheduleSearch, setDateScheduleSearch] = useState<any[]>([query?.start_schedule_upload_date ? moment(query?.start_schedule_upload_date, 'Y-MM-DD').toDate() : null, query?.end_schedule_upload_date ? moment(query?.end_schedule_upload_date || '', 'Y-MM-DD').toDate() : null]);
    const [startDateSchedule, endDateSchedule] = dateScheduleSearch;

    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => state.News;

    const NewsProperties = createSelector(
        selectLayoutState,
        (state) => ({
            newsStockSchedules: state.newsStockSchedules,
            isNewsStockScheduleSuccess: state.isNewsStockScheduleSuccess,
            isNewsStockScheduleLoading: state.isNewsStockScheduleLoading,
            error: state.error,
        })
    );

    // Inside your component
    const { newsStockSchedules, error, isNewsStockScheduleLoading } = useSelector(NewsProperties);

    useEffect(() => {
        dispatch(onGetNewsStockSchedules(query));
    }, [JSON.stringify(query)]);

    const searchData = () => {
        const queryNew = {
            ...query,
            status: statusSearch?.value || '',
            start_schedule_upload_date: startDateSchedule ? moment(new Date(startDateSchedule)).format("Y-MM-DD") : '',
            end_schedule_upload_date: endDateSchedule ? moment(new Date(endDateSchedule)).format("Y-MM-DD") : '',
            start_created_at: startDateCreated ? moment(new Date(startDateCreated)).format("Y-MM-DD") : '',
            end_created_at: endDateCreated ? moment(new Date(endDateCreated)).format("Y-MM-DD") : '',
            page: 1,
            time_request: + new Date()
        };
        setQuery(queryNew);
    };

    const resetData = () => {
        const queryNew = {
            ...query,
            status: String(EXCEL_UPLOAD_STATUS_OPTIONS[0]?.value),
            start_schedule_upload_date: '',
            end_schedule_upload_date: '',
            start_created_at: moment().format('Y-MM-DD'),
            end_created_at: moment().format('Y-MM-DD'),
            order_by: 'ASC',
            type: String(EXCEL_UPLOAD_TYPE.STOCK_NEWS),
            sort_by: TYPE_SELECT_DEFAULT,
            time_request: + new Date(),
            page: 1,
        };
        setQuery(queryNew, "push");
        setStatusSearch((_prev) => EXCEL_UPLOAD_STATUS_OPTIONS[0]);
        setDateCreatedSearch([queryNew?.start_created_at ? moment(queryNew?.start_created_at || "", 'Y-MM-DD').toDate() : null, queryNew?.end_created_at ? moment(queryNew?.end_created_at || "", 'Y-MM-DD').toDate() : null]);
        setDateScheduleSearch([queryNew?.start_schedule_upload_date ? moment(queryNew?.start_schedule_upload_date || "", 'Y-MM-DD').toDate() : null, queryNew?.end_schedule_upload_date ? moment(queryNew?.end_schedule_upload_date || "", 'Y-MM-DD').toDate() : null]);
    };

    const triggerRefresh = async (type: string = '') => {
        setQuery({
            ...query,
            time_request: + new Date(),
        }, "push");
    }
    //End::Update


    // Begin::Cancel
    const [isOpenConfirm, setIsConfirm] = useState<boolean>(false);
    const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
    const [initialValueCancel, setInitialValueCancel] = useState<any | null>(null);

    const handleConfirmCancel = (item: any | null) => {
        setInitialValueCancel((_prev: any) => item);
        setIsConfirm((_prev) => true);
    };

    const handleActionCancel = async () => {
        if (!(initialValueCancel?.id)) { return; };
        try {
            setIsConfirmLoading((_prev) => true);
            const response: any = await cancelNewsStockSchedule(initialValueCancel?.id);
            if (response?.code === 200) {
                dispatch(onGetNewsStockSchedules(query));
                setIsConfirmLoading((_prev) => false);
                setIsConfirm((_prev) => false);
                setInitialValueCancel((_prev: any) => null);
                toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
            } else {
                setIsConfirmLoading((_prev) => false);
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsConfirmLoading((_prev) => false);
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };


    const onCloseConfirmClick = () => {
        setInitialValueCancel((_prev: any) => null);
        setIsConfirm((_prev) => false);
    }

    // Column
    const columns = useMemo(
        () => [
            {
                Header: t('ID'),
                accessor: "id",
                filterable: true,
                sortable: true,
                thWidth: 100,
                thClass: "align-middle text-center",
                Cell: (cell: any) => (
                    <>
                        <div className="text-center" style={{ minWidth: '80px' }}>
                            <CopyWrapper contentCopy={cell?.value}>
                                {cell?.value}
                            </CopyWrapper>
                        </div>

                    </>
                ),
            },
            {
                Header: t('Status'),
                accessor: "status",
                filterable: true,
                sortable: false,
                thWidth: 130,
                thClass: 'align-middle text-start',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const label = EXCEL_UPLOAD_STATUS_OPTIONS_LANG?.find((s) => String(s?.value) === String(cell?.value))?.label || '';
                    const labelColor = EXCEL_UPLOAD_STATUS_OPTIONS_COLOR[`${cell?.value || '1'}` as keyof typeof EXCEL_UPLOAD_STATUS_OPTIONS_COLOR] || 'primary';
                    return (<div style={{ minWidth: '100px' }} className="text-start">
                        <span className={`rounded-pill badge bg-${labelColor}-subtle text-${labelColor} fs-12`}>
                            {label}
                        </span>
                    </div>)
                },
            },
            {
                Header: t('File Name'),
                accessor: "name",
                filterable: true,
                sortable: true,
                thWidth: 150,
                thClass: 'align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div className="d-flex justify-content-between align-items-center">
                            {item?.name || '-'}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Total Rows'),
                accessor: "total_row",
                filterable: true,
                sortable: true,
                thWidth: 150,
                thClass: 'align-middle text-center',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div className="text-center">
                            {formatNumberWithCommas(item?.total_row || 0)}
                        </div>
                    </>)
                },
            },
            {
                Header: t('AI Model'),
                accessor: "ai_model",
                filterable: true,
                sortable: false,
                thWidth: 150,
                thClass: 'align-middle text-center',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div className="text-center">
                            {AI_MODEL_NEWS_STOCK_OPTIONS_LANG?.find((_item: any) => String(_item?.value) === String(item?.ai_model))?.label || '-'}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Schedule at'),
                accessor: "schedule_upload_date",
                filterable: true,
                sortable: true,
                thWidth: 150,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (
                        <div className="text-end pe-3" style={{ minWidth: '120px' }}>
                            <strong><span className="">{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </strong>
                        </div>
                    )
                },
            },

            {
                Header: t('Created At'),
                accessor: "created_at",
                filterable: true,
                sortable: true,
                thWidth: 150,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (
                        <div className="text-end pe-3" style={{ minWidth: '120px' }}>
                            <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
                        </div>
                    )
                },
            },
            {
                Header: t('Updated at'),
                accessor: "updated_at",
                filterable: true,
                sortable: false,
                thWidth: 150,
                thClass: 'text-end align-middle',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (
                        <div className="text-end" style={{ minWidth: '120px' }}>
                            <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
                        </div>
                    )
                },
            },
            {
                Header: t('Actions'),
                accessor: "__",
                thClass: 'align-middle text-center',
                thWidth: 100,
                sortable: false,
                Cell: (cell: any) => {
                    const item: any = cell?.row?.original;
                    return (
                        <ul className="list-inline flex-wrap justify-content-center hstack gap-2 mb-0" style={{ minWidth: '80px' }}>
                            {isHavePermissionRole(ROLES_FOR_APP.NEWS_STOCK, userPermissions) && (
                                <TooltipCustom
                                    title={t('Button Cancel')}
                                    id={`detail-cp-${item?.id}`}
                                >
                                    <li className="list-inline-item" id={`detail-cp-${item?.id}`}>
                                        <Link className="btn btn-sm btn-soft-danger edit-item-btn" to="#"
                                            onClick={(e) => { e.preventDefault(); handleConfirmCancel(item) }}
                                        >
                                            <i className="ri-close-fill align-bottom"></i> {t('Button Cancel')}
                                        </Link>
                                    </li>
                                </TooltipCustom>
                            )}
                        </ul>
                    );
                },
            },
        ],
        [i18n?.language, JSON.stringify(query), JSON.stringify(userPermissions)]
    );

    const handleChangePage = useCallback((page: any) => {
        setQuery({ page: page + 1 })
    }, []);

    const handleChangeSorting = useCallback((sortBy: any) => {
        setQuery((_prev: any) => {
            return ({ ..._prev, ...sortBy });
        });
    }, []);

    const handleChangePickerCreated = (values: any[] = []) => {
        setDateCreatedSearch((_prev: any) => values);
    }

    const handleChangePickerSchedule = (values: any[] = []) => {
        setDateScheduleSearch((_prev: any) => values);
    }

    return (
        <React.Fragment>
            <Row>
                {isHavePermissionRole(ROLES_FOR_APP.NEWS_STOCK, userPermissions) && (
                    <Col lg={12}>
                        <div>
                            <CardHeader className="border-0">
                                <Row className="g-4 align-items-center">
                                    <div className="col-5">
                                        <div>
                                            <h5 className="card-title mb-0 d-flex flex-wrap gap-1 gap-xxl-2">
                                                <span>
                                                    <span className="me-2">{t('Total')}:</span>
                                                    {(isNewsStockScheduleLoading && query?.page === 1) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                                        start={0}
                                                        end={newsStockSchedules?.pagination?.total || 0}
                                                        duration={1}
                                                        className="text-primary"
                                                    />)}
                                                </span>
                                                <span className="text-muted">|</span>
                                                <span className="d-flex">
                                                    <div className="me-2">{t('Initial')}:</div>
                                                    {(isNewsStockScheduleLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                                        start={0}
                                                        end={newsStockSchedules?.pagination?.init_count || 0}
                                                        duration={1}
                                                        className="text-primary"
                                                    />)}
                                                </span>
                                                <span className="text-muted">|</span>
                                                <span className="d-flex">
                                                    <div className="me-2">{t('Cancelled')}:</div>
                                                    {(isNewsStockScheduleLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                                        start={0}
                                                        end={newsStockSchedules?.pagination?.cancel_count || 0}
                                                        duration={1}
                                                        className="text-primary"
                                                    />)}
                                                </span>
                                                <span className="text-muted">|</span>
                                                <span className="d-flex">
                                                    <div className="me-2">{t('Completed')}:</div>
                                                    {(isNewsStockScheduleLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                                        start={0}
                                                        end={newsStockSchedules?.pagination?.success_count || 0}
                                                        duration={1}
                                                        className="text-primary"
                                                    />)}
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="col-7 col-sm-7 text-end">

                                    </div>
                                </Row>
                            </CardHeader>
                            <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                                <Row className="g-4 align-items-center mt-0">
                                    <Col sm={6} md={6} lg={3} xl={3} xxl={3} className='mt-3  mt-3 mt-lg-2'>
                                        <LabelWrapper label={t('Status')} isShow={!!statusSearch}>
                                            <DropdownStatus
                                                name="status"
                                                dataList={EXCEL_UPLOAD_STATUS_OPTIONS_LANG || []}
                                                placeholder={`${t('Status')}...`}
                                                className="dropdown-status-rounded z-hight"
                                                classNamePrefix="name-prefix"
                                                initialValue={statusSearch || null}
                                                onChangeSelect={(e: any) => setStatusSearch(e)}
                                                isHasOptionAll={true}
                                                optionAll={{ label: t('All'), value: '' }}
                                                colors={['secondary', 'primary', 'success', 'danger', 'warning']}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={6} md={6} lg={3} xl={3} xxl={3} className='date-picker-wrapper-custom  mt-3 mt-lg-2'>
                                        <LabelWrapper label={t('Schedule at')} isShow={!!startDateSchedule || !!endDateSchedule}>
                                            <DatePickerCustom
                                                placeholder={`${t('Start Schedule at')} - ${t('End Schedule at')}`}
                                                startDate={startDateSchedule || null}
                                                endDate={endDateSchedule || null}
                                                onChangePicker={handleChangePickerSchedule}
                                                showOptions={[
                                                    'today', 'yesterday', 'two_day_ago',
                                                    'last_3_days', 'last_7_days', 'last_14_days', 'last_30_days',
                                                    'this_week', 'last_week',
                                                    'this_month', 'last_month',
                                                ]}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={6} md={6} lg={3} xl={3} xxl={3} className='date-picker-wrapper-custom  mt-3 mt-lg-2'>
                                        <LabelWrapper label={t('Created At')} isShow={!!startDateCreated || !!endDateCreated}>
                                            <DatePickerCustom
                                                placeholder={`${t('Start Created at')} - ${t('End Created at')}`}
                                                startDate={startDateCreated || null}
                                                endDate={endDateCreated || null}
                                                onChangePicker={handleChangePickerCreated}
                                                showOptions={[
                                                    'today', 'yesterday', 'two_day_ago',
                                                    'last_3_days', 'last_7_days', 'last_14_days', 'last_30_days',
                                                    'this_week', 'last_week',
                                                    'this_month', 'last_month',
                                                ]}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={6} md={6} lg={3} xl={3} xxl={3} className="hstack gap-1 justify-content-center justify-content-sm-end justify-content-lg-start mt-3 mt-lg-2">
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-primary me-2 "
                                                onClick={searchData}
                                                disabled={isNewsStockScheduleLoading}
                                            >
                                                <i className="ri-search-line align-bottom me-1"></i>{" "}
                                                {t('Button Search')}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary fs-14"
                                                onClick={resetData}
                                            >
                                                <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                                {t('Button Reset')}
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <CardBody className="pt-3">
                                <TableContainer
                                    className="custom-header-css"
                                    divClass="table-responsive table-card"
                                    tableClass="align-middle sticky-table-log-news-recomposition"
                                    theadClass="table-light"
                                    columns={columns}
                                    data={newsStockSchedules?.list?.length ? newsStockSchedules?.list : []}
                                    customPageSize={query.limit}
                                    customPageIndex={query.page - 1}
                                    totalRecords={newsStockSchedules?.pagination?.total}
                                    customPageCount={Math.ceil(Number(newsStockSchedules?.pagination?.total) / Number(newsStockSchedules?.pagination?.limit))}
                                    handleChangePage={handleChangePage}
                                    manualSorting={true}
                                    sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                                    handleChangeSorting={handleChangeSorting}
                                    isLoading={isNewsStockScheduleLoading}
                                    isShowHeaderTableFixedTab={activeTab}
                                />
                            </CardBody>
                        </div>
                    </Col>
                )}
            </Row>

            <ModalConfirm
                header={t('Button Cancel')}
                title={t('Are you sure you want to cancel?')}
                content={t('After confirming the cancel action, the data will be cancelled and cannot be recovered. Do you want to proceed with the cancel action.')}
                isShowIcon={false}
                textButtonClose={t('Button Close')}
                textButtonConfirm={t('Button Cancel')}
                classButtonConfirm="btn-danger"
                classIconButtonConfirm=""
                isShowButtonConfirm={true}
                isOpen={isOpenConfirm}
                isLoading={isConfirmLoading}
                onClose={onCloseConfirmClick}
                onConfirm={handleActionCancel}
            />

            <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={3000} limit={2} />
        </React.Fragment >
    );
};

export default ScheduleList;